<!--  -->
<template>
    <div class="gardenEdit">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="116px" class="ruleForm">
            <div class="module bgc box-shadow">
                <div class="title_box">
                    <p class="title">基本信息</p>
                </div>
                <el-form-item label="园区名称" prop="name">
                    <el-input class="width810" placeholder="请输入园区名称 " v-model="form.name" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="regoin">
                    <el-cascader class="width440" v-model="form.regoin" placeholder="请选择所在地区" :options="options" @change="regoinChange"></el-cascader>
                </el-form-item>
                <el-form-item label="园区性质">
                    <el-select v-model="form.parktype" class="width440" placeholder="请选择园区性质">
                        <el-option v-for="(item, index) in gardenNature" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="园区级别">
                    <el-select v-model="form.parklevel" class="width440" placeholder="请选择园区级别">
                        <el-option v-for="(item, index) in gardenRank" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="园区面积">
                    <el-input class="width440" v-model="form.areainfo" placeholder="请填写园区面积，如0.2平方公里"></el-input>
                </el-form-item>
                <el-form-item label="所在地址">
                    <div @click="showLocationDialog">
                        <el-input class="width440" v-model="form.address" placeholder="请填写所在地址"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="官方联系电话">
                    <el-input class="width810" v-model="form.officialtel" placeholder="请填写官方联系电话" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="官方网站">
                    <el-input class="width810" v-model="form.officialsite" placeholder="请填写官方网站" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="官方微博地址">
                    <el-input class="width810" v-model="form.officialweibo" placeholder="请填写官方微博地址" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="官方公众号图片" class="officialmpurl">
                    <div class="content">
                        <div class="left_img">
                            <i class="el-icon-picture" v-if="!form.officialmpurl"></i>
                            <img v-else :src="form.officialmpurl + '?' + time" alt="">
                            <img class="close" @click="deleteOfficialmpurl" v-if="form.officialmpurl" :src="require('@/common/images/cms/close.png')" alt="">
                        </div>
                        <div class="right_btn">
                            <UploadFile :fileRule="fileRule1" :uploadType="uploadType1" @setFile="getOfficialmpurl" />
                            <p class="tips">建议尺寸1:1，JPG、PNG格式，图片小于100KB</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="资鲸联系电话">
                    <el-input class="width810" v-model="form.capwhalelinktel" placeholder="请填写资鲸联系电话" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="资鲸联系名称" class="no_margin">
                    <el-input class="width810" v-model="form.capwhalelinkman" placeholder="请填写资鲸联系名称" maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </div>
            <div class="module bgc box-shadow">
                <div class="title_box">
                    <p class="title">运营信息</p>
                </div>
                <el-form-item label="封面图片" class="coverurl" prop="coverurl">
                    <div class="content">
                        <div class="left_img">
                            <i class="el-icon-picture" v-if="!form.coverurl"></i>
                            <img v-else :src="form.coverurl + '?' + time" alt="">
                            <img class="close" @click="deleteCoverurl" v-if="form.coverurl" :src="require('@/common/images/cms/close.png')" alt="">
                        </div>
                        <div class="right_btn">
                            <div class="btn">
                                <UploadFile :fileRule="fileRule2" :uploadType="uploadType1" @setFile="getCoverurl" />
                                <el-button type="warning" @click="openCoverScrollBox">素材库</el-button>
                            </div>
                            <p class="tips">建议尺寸750*422px或16：9，JPG、PNG格式， 图片小于5M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="主页背景图" class="pagebgurl" prop="pagebgurl">
                    <div class="content">
                        <div class="left_img">
                            <i class="el-icon-picture" v-if="!form.pagebgurl"></i>
                            <img v-else :src="form.pagebgurl + '?' + time" alt="">
                            <img class="close" @click="deletePagebgurl" v-if="form.pagebgurl" :src="require('@/common/images/cms/close.png')" alt="">
                        </div>
                        <div class="right_btn">
                            <div class="btn">
                                <UploadFile :fileRule="fileRule3" :uploadType="uploadType1" @setFile="getPagebgurl" />
                                <el-button type="warning" @click="openPagebgScrollBox">素材库</el-button>
                            </div>
                            <p class="tips">建议尺寸1920*200px，JPG、PNG格式， 图片小于5M。</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="宣传素材" class="promomaterialtype">
                    <div class="content">
                        <el-radio-group v-model="form.promomaterialtype">
                            <el-radio :label="1">图片</el-radio>
                            <el-radio :label="2">视频</el-radio>
                        </el-radio-group>
                        <div class="upload_img" v-if="form.promomaterialtype === 1">
                            <div class="btn">
                                <UploadFile ref="uploadPromoimgurls" :fileRule="fileRule3" :uploadType="uploadType1" @setFile="getPromoimgurls" />
                                <el-button type="warning" @click="openPromoimgScrollBox">素材库</el-button>
                            </div>
                            <p class="tips">建议尺寸750*422px或16：9，JPG、PNG格式， 图片小于5M；最多上传五张，如不上传默认使用封面图。</p>
                            <div class="promoimgurls" v-if="form.promoimgurls.length">
                                <div class="item" v-for="(item, index) in form.promoimgurls" :key="index">
                                    <img :src="item + '?' + time" alt="">
                                    <img class="close" @click="deletePromoimgurl(index)" :src="require('@/common/images/cms/close.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="upload_video" v-if="form.promomaterialtype === 2">
                            <p class="tips">格式支持mp3、m4a，为保证音频加载与播放的流畅性，建议上传大小不超过1G</p>
                            <div class="promovideourl" v-if="form.promovideourl">
                                <div class="img">
                                    <i class="el-icon-picture"></i>
                                    <!-- <img v-else :src="form.promovideocoverurl + '?' + time" alt=""> -->
                                </div>
                                <div class="promovideoname">{{form.promovideourl}}</div>
                                <div class="delete" @click="deletePromovideourl">删除</div>
                            </div>
                            <div class="btn">
                                <el-button @click="openPromovideoScrollBox">选择已有内容</el-button>
                                <UploadFileVideo :fileRule="fileRule4" :uploadType="uploadType2" @setFile="getPromovideourl" />
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="园区简介" class="uEditor_content">
                    <uEditor :content="form.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
                </el-form-item>
                <el-form-item label="园区特色" class="textarea_box">
                    <el-input class="width810" type="textarea" placeholder="请填写园区特色" v-model="form.feature" maxlength="500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="园区优势" class="textarea_box">
                    <el-input class="width810" type="textarea" placeholder="请填写园区优势" v-model="form.advantage" maxlength="500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="主导产业" class="mainindustry">
                    <el-select multiple filterable v-model="form.mainindustry" class="width810" placeholder="请选择/输入主导产业">
                        <el-option v-for="(item, index) in mainindustryList" :key="index" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="园区政策" class="mainpolicy">
                    <el-select multiple filterable v-model="form.mainpolicy" class="width810" placeholder="请选择/输入园区政策">
                        <el-option v-for="(item, index) in mainpolicyList" :key="index" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="园区服务" class="mainservice">
                    <el-select multiple filterable v-model="form.mainservice" class="width810" placeholder="请选择/输入园区服务">
                        <el-option v-for="(item, index) in mainserviceList" :key="index" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目入驻标准" class="textarea_box">
                    <el-input class="width810" type="textarea" placeholder="请填写项目入驻标准" v-model="form.entrycriterion" maxlength="200" show-word-limit></el-input>
                </el-form-item>
            </div>
            <div class="module bgc box-shadow padding-20">
                <div class="btn_module">
                    <el-button type="primary" @click="submit(0)">发布</el-button>
                    <el-button type="warning" @click="submit(1)" v-if="!$route.query.innerid || ($route.query.innerid && form.status === 0)">存至草稿</el-button>
                    <el-button @click="handleCancel">取消</el-button>
                </div>
            </div>
        </el-form>
        <scrollBox ref="coverScrollBox" :uploadType="uploadType1" @saveMaterialFile="getCoverurl"></scrollBox>
        <scrollBox ref="pagebgScrollBox" :uploadType="uploadType1" @saveMaterialFile="getPagebgurl"></scrollBox>
        <scrollBox ref="promoimgScrollBox" :uploadType="uploadType1" @saveMaterialFile="getPromoimgurls"></scrollBox>
        <scrollBox ref="promovideoScrollBox" :uploadType="uploadType2" @saveMaterialFile="getPromovideourl"></scrollBox>
        <ChooseLocation v-if="($route.query.innerid && form.name) || !$route.query.innerid" :lat="form.latitude" :lng="form.longitude" :provincename="form.mapprovince" :cityname="form.mapcity" :currentArea="form.address" :locationDialog="locationDialogStatus" @close="locationDialogStatus=false" @thePosition="getThePosition" />
    </div>
</template>

<script>
import citys from 'common/js/citys.json'
import ChooseLocation from 'views/activeOperate/components/chooseLocation'
import UploadFile from '@/base/upload/uploadFile2'
import ScrollBox from '@/base/scrollBox/scrollBox'
import UEditor from 'base/uEditor/uEditor3'
import UploadFileVideo from 'base/upload/uploadFileResume'
import {uploadGovparksinfo, getGovparksinfo} from 'api/gardenApi'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            form: {
                name:'', // 园区名称
                regoin: '', // 所在地区
                parktype: 1, // 园区性质
                parklevel: 1, // 园区级别
                areainfo: '', // 园区面积
                address: '', // 所在地址
                officialtel: '', // 官方联系电话
                officialsite: '', // 官方网站
                officialweibo: '', // 官方微博地址
                officialmpurl: '', // 官方公众号图片url
                officialmpid: '', // 官方公众号图片id
                capwhalelinktel: '', // 资鲸联系电话
                capwhalelinkman: '', // 资鲸联系人
                coverid: '', // 园区封面图id
                coverurl: '', // 园区封面图url
                pagebgid: '', // 主页背景图id
                pagebgurl: 'https://img.capwhale.com/capwhale/govpark_bg_default.jpg', // 主页背景图url
                promomaterialtype: 1, // 宣传素材 1图片 2视频
                promovideoid: '', // 宣传视频id
                promovideourl: '', // 宣传视频url
                promovideoname: '', // 宣传视频名称
                promovideocoverurl: '', // 宣传视频封面
                promoimgids: [], // 宣传图id
                promoimgurls: [], // 宣传图url
                content: '', // 园区介绍
                feature: '', // 园区特色
                advantage: '', // 园区优势
                mainindustry: [], // 主导产业
                mainpolicy: [], // 园区政策
                mainservice: [], // 园区服务
                entrycriterion: '', // 项目入驻标准,
                isdraft: '', // 是否是草稿 0否1是
                cityid: '', // 城市代码
                cityname: '', // 城市名称
                countyid: '', // 区县代码
                countyname: '', // 区县名称
                provinceid: '', // 省份代码
                provincename: '', // 省份名称
                latitude:  '',// 纬度
                longitude: '',//经度
                mapprovince: '',
                mapcity: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入园区名称', trigger: 'blur'}
                ],
                regoin: [
                    {required: true, message: '请选择园区所在地区', trigger: 'blur'}
                ],
                coverurl: [
                    {required: true, message: '请上传封面图片', trigger: 'blur'}
                ],
                pagebgurl: [
                    {required: true, message: '请上传主页背景图', trigger: 'blur'}
                ]
            },
            options: citys,
            gardenNature: [
                {label: '政府性质', value: 1},
                {label: '企业性质', value: 2}
            ],
            gardenRank: [
                {label: '国家级', value: 1},
                {label: '市级', value: 2},
                {label: '区级', value: 3}
            ],
            mainindustryList: [
                {label: '新一代信息技术产业'},
                {label: '人工智能和工业互联网产业'},
                {label: '大数据云计算产业'},
                {label: '数字创意产业'},
                {label: '高端装备制造业'},
                {label: '新能源产业'},
                {label: '汽车制造业'},
                {label: '传统制造业'},
                {label: '现代服务业'},
                {label: '金融服务业'},
                {label: '零售贸易物流业'},
                {label: '交通出行服务业'},
                {label: '旅游业'},
                {label: '医疗医药产业'},
                {label: '新材料产业'},
                {label: '生物产业'},
                {label: '节能环保产业'},
                {label: '农林渔牧业'},
                {label: '建筑/地产'},
                {label: '其他'}
            ],
            mainpolicyList: [
                {label: '核定征收'},
                {label: '免增值税'},
                {label: '个税优惠'},
                {label: '免企业所得税优惠'},
                {label: '人才落户'},
                {label: '房租补贴'}
            ],
            mainserviceList: [
                {label: '融资补贴'},
                {label: '银行贷款贴息'},
                {label: '土地补贴（租金或购置费)'},
                {label: '土地使用税补贴'},
                {label: '固定资产投资补贴'},
                {label: '创业扶持'},
                {label: '房租补贴'},
                {label: '固定资产抵扣'},
                {label: '研发及设备补贴'},
                {label: '行政规费减免'},
                {label: '产业类型鼓励'},
                {label: '水电等配套补助'}
            ],
            fileRule1: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 0.01,
                width: 120,
                height: 120,
                nottype: true
            },
            uploadType1: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            fileRule2: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 750,
                height: 422,
                nottype: true
            },
            fileRule3: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/jpg',
                size: 5,
                width: 1920,
                height: 200,
                nottype: true
            },
            fileRule4: {
                btnName: '上传本地视频',
                cls: '',
                accept: 'video/mp4',
                size: 1024,
                width: '',
                height: '',
                nottype: true
            },
            uploadType2: {
                catecode: '103',
                datatype: 'VIDEO',
                attid: '',
                url: ''
            },
            time: new Date().getTime(),
            locationDialogStatus: false
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.innerid) {
            this.getGovparksinfo()
        }
        console.log(this.options)
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleCancel() {
            this.$router.back(1)
        },
        deletePromoimgurl(index) {
            this.form.promoimgurls.splice(index, 1)
        },
        getThePosition(data) {
            // this.form.mapalladdress = data.province + data.city + data.detailPosition
            this.form.address = data.detailPosition
            this.locationDialogStatus = false
            this.form.latitude = data.point.lat
            this.form.longitude = data.point.lng
            this.form.mapprovince = data.province
            this.form.mapcity = data.city
            console.log(data)
        },
        // 选择活动地址
        showLocationDialog() {
            this.locationDialogStatus = true
        },
        regoinChange(e) {
            console.log(e)
        },
        getOfficialmpurl(file) {
            this.time = new Date().getTime()
            this.form.officialmpurl = file.furl
            this.form.officialmpid = file.key
        },
        getCoverurl(file) {
            this.time = new Date().getTime()
            this.form.coverurl = file.furl
            this.form.coverid = file.key
        },
        getPagebgurl(file) {
            this.time = new Date().getTime()
            this.form.pagebgurl = file.furl
            this.form.pagebgid = file.key
        },
        getUEditorContent(content) {
            this.form.content = content
        },
        deleteOfficialmpurl() {
            this.form.officialmpurl = ''
            this.form.officialmpid = ''
        },
        deleteCoverurl() {
            this.form.coverurl = ''
            this.form.coverid = ''
        },
        deletePagebgurl() {
            this.form.pagebgurl = ''
            this.form.pagebgid = ''
        },
        deletePromovideourl() {
            this.form.promovideourl = ''
            this.form.promovideoid = ''
            this.form.promovideoname = ''
        },
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        openPagebgScrollBox() {
            this.$refs.pagebgScrollBox.openDialog()
        },
        openPromoimgScrollBox() {
            this.$refs.promoimgScrollBox.openDialog()
        },
        openPromovideoScrollBox() {
            this.$refs.promovideoScrollBox.openDialog()
        },
        getPromoimgurls(file) {
            if (this.form.promoimgurls.length < 5) {
                this.form.promoimgurls.push(file.furl)
                this.form.promoimgids.push(file.key)
                this.$refs.uploadPromoimgurls.uploadSetting.uploadauth = ''
            } else {
                this.$message.warning('宣传图最多上传5张哦')
            }
        },
        getPromovideourl(file) {
            this.form.promovideourl = file.furl
            // this.form.promovideocoverurl = file.coveratturl
            this.form.promovideoid = file.key
            // this.form.promovideoname = file.fname
            console.log(this.form, file)
        },
        submit(isdraft) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.options.some((item, index) => {
                        if (item.value === this.form.regoin[0]) {
                            this.form.provinceid = this.form.regoin[0]
                            this.form.provincename = item.label
                            item.children.some(obj => {
                                if (obj.value === this.form.regoin[1]) {
                                    this.form.cityid = this.form.regoin[1]
                                    this.form.cityname = obj.label
                                    obj.children.some(options => {
                                        if (options.value === this.form.regoin[2]) {
                                            this.form.countyid = this.form.regoin[2]
                                            this.form.countyname = options.label
                                            return
                                        }
                                    })
                                    return true
                                }
                            })
                            return true
                        }
                    })
                    const form = JSON.parse(JSON.stringify(this.form))
                    form.promoimgids = form.promoimgids.join(',')
                    form.promoimgurls = form.promoimgurls.join(',')
                    form.mainindustry = form.mainindustry.join(',')
                    form.mainpolicy = form.mainpolicy.join(',')
                    form.mainservice = form.mainservice.join(',')
                    form.isdraft = isdraft
                    this.setLoading(true)
                    uploadGovparksinfo({
                        data: form,
                        success: res => {
                            this.setLoading(false)
                            this.$router.push({name: 'GardenList'})
                            console.log(res)
                        },
                        error: res => {
                            this.setLoading(false)
                            this.$message.error(res.msg)
                        }
                    })
                    console.log(this.form)
                } else {
                    this.$message.error('请完善您的数据！')
                }
            })
        },
        getGovparksinfo() {
            this.setLoading(true)
            getGovparksinfo({
                data: {innerid: this.$route.query.innerid},
                success: res => {
                    this.setLoading(false)
                    res.data.regoin = [res.data.provinceid, res.data.cityid, res.data.countyid]
                    this.$refs.uEditor.init(res.data.content)
                    // res.data.promovideoname = ''
                    // res.data.promovideocoverurl = ''
                    this.form = res.data
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ChooseLocation,
        UploadFile,
        ScrollBox,
        UEditor,
        UploadFileVideo
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .gardenEdit {
        .ruleForm {
            .module {
                margin-bottom: 18px;
                padding-bottom: 30px;
                .title_box {
                    padding: 20px;
                    border-bottom: 1px solid #DCDFE6;
                    margin-bottom: 20px;
                    .title {
                        padding-left: 8px;
                        border-left: 2px solid #409EFF;
                        font-weight: bold;
                    }
                }
                .el-form-item {
                    padding-left: 30px;
                    .el-form-item__label {
                        text-align: left;
                        color: #303133;
                    }
                    .width810 {
                        width: 810px;
                    }
                    .width440 {
                        width: 440px;
                    }
                    .el-select {
                        .el-select__caret {
                            line-height: 32px;
                        }
                    }
                }
                .officialmpurl {
                    .el-form-item__label {
                        line-height: 20px;
                    }
                    .content {
                        display: flex;
                        align-items: center;
                        .left_img {
                            width: 120px;
                            height: 120px;
                            background: #F5F7FA;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 38px;
                            color: #DCDFE6;
                            margin-right: 30px;
                            position: relative;
                            img {
                                width: 120px;
                                height: 120px;
                                border-radius: 4px;
                            }
                            .close {
                                width: 20px;
                                height: 20px;
                                position: absolute;
                                top: -10px;
                                right: -10px;
                                cursor: pointer;
                            }
                        }
                        .right_btn {
                            .tips {
                                color: #909399;
                                font-size: 14px;
                                line-height: 20px;
                            }
                        }
                    }
                }
                .no_margin {
                    margin-bottom: 0;
                }
                .coverurl {
                    .el-form-item__label {
                        line-height: 20px;
                    }
                    .content {
                        display: flex;
                        align-items: center;
                        .left_img {
                            width: 318px;
                            height: 178px;
                            margin-right: 12px;
                            font-size: 38px;
                            background: #F5F7FA;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #DCDFE6;
                            position: relative;
                            img {
                                width: 318px;
                                height: 178px;
                                border-radius: 4px;
                            }
                            .close {
                                width: 20px;
                                height: 20px;
                                position: absolute;
                                top: -10px;
                                right: -10px;
                                cursor: pointer;
                            }
                        }
                        .right_btn {
                            .btn {
                                display: flex;
                                align-items: center;
                                .el-button--warning {
                                    margin-left: 20px;
                                }
                            }
                            .tips {
                                color: #C0C4CC;
                                font-size: 14px;
                                line-height: 20px;
                            }
                        }
                    }
                }
                .pagebgurl {
                    .el-form-item__label {
                        line-height: 20px;
                    }
                    .content {
                        display: flex;
                        align-items: center;
                        .left_img {
                            width: 318px;
                            height: 92px;
                            margin-right: 14px;
                            font-size: 38px;
                            background: #F5F7FA;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #DCDFE6;
                            position: relative;
                            img {
                                width: 318px;
                                height: 92px;
                                border-radius: 4px;
                            }
                            .close {
                                width: 20px;
                                height: 20px;
                                position: absolute;
                                top: -10px;
                                right: -10px;
                                cursor: pointer;
                            }
                        }
                        .right_btn {
                            .btn {
                                display: flex;
                                align-items: center;
                                .el-button--warning {
                                    margin-left: 20px;
                                }
                            }
                            .tips {
                                color: #C0C4CC;
                                font-size: 14px;
                                line-height: 20px;
                            }
                        }
                    }
                }
                .promomaterialtype {
                    .el-form-item__label {
                        line-height: 20px;
                    }
                    .content {
                        .el-radio-group {
                            margin-bottom: 18px;
                            .is-checked {
                                .el-radio__label {
                                    color: #303133;
                                }
                            }
                        }
                        .upload_img {
                            .btn {
                                display: flex;
                                align-items: center;
                                margin-bottom: 10px;
                                .el-button--warning {
                                    margin-left: 20px;
                                }
                            }
                            .tips {
                                font-size: 14px;
                                color: #C0C4CC;
                                line-height: 20px;
                            }
                            .promoimgurls {
                                margin-top: 30px;
                                display: flex;
                                align-items: center;
                                .item {
                                    position: relative;
                                    margin-right: 15px;
                                    img {
                                        width: 144px;
                                        height: 80px;
                                        border-radius: 4px;
                                    }
                                    .close {
                                        width: 14px;
                                        height: 14px;
                                        position: absolute;
                                        top: -7px;
                                        right: -7px;
                                    }
                                }
                            }
                        }
                        .upload_video {
                            .tips {
                                font-size: 14px;
                                color: #C0C4CC;
                                line-height: 20px;
                            }
                            .promovideourl {
                                width: 420px;
                                box-sizing: border-box;
                                padding: 12px;
                                background: #F5F7FA;
                                border: 1px solid #D8DCE6;
                                border-radius: 4px;
                                margin-top: 10px;
                                display: flex;
                                align-items: center;
                                .img {
                                    width: 46px;
                                    height: 26px;
                                    background:  #D8DCE6;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 16px;
                                    color:#F5F7FA;
                                    margin-right: 12px;
                                    img {
                                        width: 46px;
                                        height: 26px;
                                    }
                                }
                                .promovideoname {
                                    width: 254px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    margin-right: 40px;
                                }
                                .delete {
                                    font-size: 14px;
                                    color: #FF4747;
                                    cursor: pointer;
                                }
                            }
                            .btn {
                                display: flex;
                                align-items: center;
                                margin-top: 20px;
                                .el-button {
                                    margin-right: 20px;
                                }
                            }
                        }
                    }
                }
                .uEditor_content{
                    .edui-editor {
                        width: 810px !important;
                        .edui-editor-iframeholder {
                            width: 808px !important;
                        }
                    }
                }
                .textarea_box {
                    .el-textarea {
                        height: 90px;
                        .el-textarea__inner {
                            height: 90px;
                            resize: none;
                        }
                        .el-input__count {
                            background: transparent;
                            bottom: -10px;
                            right: 20px;
                        }
                    }
                }
                .mainindustry, .mainpolicy, .mainservice {
                    .el-input--suffix {
                        height: auto;
                    }
                    .el-select__tags {
                        // top: 62%;
                        // .el-tag {
                        //     display: none;
                        // }
                        // .el-tag:nth-of-type(1) {
                        //     display: block;
                        // }
                        // .el-tag:nth-of-type(2) {
                        //     display: block;
                        // }
                        // .el-tag:nth-of-type(3) {
                        //     display: block;
                        // }
                        // .el-tag:nth-of-type(4) {
                        //     display: block;
                        // }
                    }
                }
                .isrecommend {
                    .is-checked {
                        .el-radio__label {
                            color: #303133;
                        }
                    }
                    .tips {
                        color: #999999;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
                .is-required {
                    .el-form-item__label::before {
                        content: '';
                        display: none;
                    }
                    .el-form-item__label::after {
                        content: '*';
                        color: #F56C6C;
                        margin-right: 4px;
                    }
                }
                .btn_module {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .el-button--primary {
                        margin-right: 32px;
                    }
                    .el-button--warning {
                        margin-right: 32px;
                        margin-left: 0;
                    }
                    .el-button--default {
                        margin-left: 0;
                    }
                }

            }
        }   
    }
</style>